import { z } from "zod";
import { IconLinkSchema } from "../IconLink";
export const AvailabilitySchema = z.object({
    title: z.string().optional(),
    links: z.array(IconLinkSchema).optional(),
});
//# sourceMappingURL=index.js.map